import React, {Component} from 'react';
import styled from 'styled-components';

import PhoneInput from './PhoneInput';

import bottle from './image/bottle.jpg';

const Background = styled.div`
    width: 100vw;
    height: 90vh;
    background-image: url(${bottle});
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 5vw 0;
`;

const Form = styled.form`
    font-size: 12vw;
    background-color: rgba(0, 0, 0, .75);
    border: 1px solid rgba(255, 0, 0, .5);
    border-radius: .5em;
    width: 90vw;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: .125em 0 .25em;
`;

const Button = styled.button.attrs({
    children: 'Send Invitation'
})`
    color: #000;
    background: #f00;
    border: none;
    margin-top: .5em;
    font-size: 10vw;
    border-radius: .5em;
    padding: .25em .5em;
    outline-color: transparent;
    
    &:disabled {
        opacity: 0.25;
    }
    
    transition: opacity .25s;
`;

const Message = styled.div`
    color: #fff;
    font-size: 10vw;
    background: rgba(255, 0, 0, .5);
    border: 2px solid rgba(255, 0, 0, 1);
    text-align: center;
    padding: .5em;
    border-radius: .5em;
`;

class App extends Component {
    state = {
        valid: false,
        submits: 0,
        message: null
    };

    onSubmit = e => {
        e.preventDefault();

        this.setState({
            message: 'Sending Invitation...'
        });

        const number = e.target.formattedPhone.value.replace(/\D+/g, '');

        if (number.length !== 10)
            return;

        fetch(`https://nauseating-apple-9276.twil.io/fukhov-yacht-form?to=${number}`, {mode: 'no-cors'})
            .then(() => {
                this.setState({
                    message: 'Invitation Sent'
                });

                setTimeout(() => {
                    this.setState({
                        valid: false,
                        submits: this.state.submits + 1,
                        message: null
                    });
                }, 2500);
            });
    };

    onValid = valid => {
        this.setState({valid});
    };

    render() {
        const {valid, submits, message} = this.state;

        return (
            <Background>
                {message ? (
                    <Message>{message}</Message>
                ) : (
                    <Form onSubmit={this.onSubmit}>
                        <PhoneInput onValid={this.onValid} submits={submits}/>
                        <Button disabled={!valid}/>
                    </Form>
                )}
            </Background>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js